import React from "react";
import { Route } from "react-router-dom";
import { InternationalCallsLoadingDialog } from "./internationalCalls-loading-dialog/InternationalCallsLoadingDialog";
import { InternationalCallsUIProvider } from "./InternationalCallsUIContext";
import { InternationalCallsCard } from "./InternationalCallsCard";
import "../../../../../_metronic/_assets/sass/pages/korek-offers/korek-offers.scss";
import { Col, Row } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux";
export function InternationalCallsPage({ history }) {
  const internationalCallsUIEvents = {
  }

  const { currentState } = useSelector(
    (state) => ({ currentState: state.internationalCalls }),
    shallowEqual
  );
  const { data } = currentState;
  
  return (
    <InternationalCallsUIProvider internationalCallsUIEvents={internationalCallsUIEvents}>
      <InternationalCallsLoadingDialog />
      <div className="korek-offers ">
        <Row className="bg-slider maxWidthCont mx-auto pb-0">
          <>
            <Col className="padding-container all-offers d-none d-md-block col-xl-12 col-sm-12 col-12" style={{
               backgroundImage: `url(${data?.image || "/media/inter-calls.png"})`, backgroundSize: "cover"
            }} xl={12} sm={12} xs={12}>
              <h1 className="title">
               {data?.upperTitle || ""}
              </h1>
              <p className="sub-title py-3">
               {data?.upperDescription || ""}
              </p>
            </Col>
            <Col className="padding-container all-offers d-block d-md-none mobile col-xl-12 col-sm-12 col-12" style={{
              height: "300px",
              backgroundImage: `url(${data?.mobileImage || "/media/inter-calls.png"})`, backgroundSize: "contain", backgroundPosition: "center"
            }} xl={12} sm={12} xs={12}>
            </Col></>
        </Row>
      </div>
      <InternationalCallsCard />
    </InternationalCallsUIProvider>
  );
}
